import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { dateFormat } from '@shared/formatters';
import { FaturamentoController } from '@modules/faturamento/controllers';
import { FaturamentoModel } from '@app/data/faturamento/models';
import { BaseListagemComponent } from '@common/modules/base/base-listagem.component';
import { DetalhesFaturamentoComponent } from '@modules/faturamento/components/detalhes-faturamento/detalhes-faturamento.component';
import { Coluna } from '@components/table/table.component';
import { Acao } from '@components/filtros/filtros.component';
import { Campo } from '@components/form/form.component';
import { modal } from '@shared/alerts/modal/modal.alert';
import { currencyBRL } from '@shared/formatters';
import { ContratoRepository } from '@app/data/contrato/contrato.repository';

@Component({
  selector: 'app-faturamento',
  templateUrl: './faturamento.component.html',
  styleUrls: ['./faturamento.component.scss'],
})
export class FaturamentoComponent extends BaseListagemComponent<FaturamentoModel> {
  protected filtros: Campo[] = [
    {
      name: 'notaFiscal.grupoContrato.numeroGrupoContrato || notaDebito.grupoContrato.numeroGrupoContrato || recibo.grupoContrato.numeroGrupoContrato',
      label: 'Contrato Master',
      type: 'text',
      icon: 'insert_drive_file',
      width: '20%',
      mask: '',
      validators: [],
    },
    {
      name: 'notaFiscal.contrato.statusId || notaDebito.contrato.statusId || recibo.contrato.statusId',
      label: 'Situação Contrato',
      value: '',
      type: 'select',
      width: '20%',
      selectOptions: {
        items: [{ label: 'Todos', value: '' }],
        filter: this.contratoRepository.filterStatus.bind(this.contratoRepository),
      },
      validators: [],
    },
    {
      name: 'notaFiscal.contrato.veiculo.placa || notaDebito.contrato.veiculo.placa || recibo.contrato.veiculo.placa',
      label: 'Placa',
      type: 'text',
      icon: 'directions_car',
      width: '20%',
      mask: '',
      validators: [],
    },
    {
      name: 'dataEmissao',
      label: 'Período Emissão',
      type: 'date-range',
      width: '20%',
      dateRangeOptions: {
        icon: 'prefix',
      },
      validators: [],
    },
    {
      name: 'notaFiscal.numeroDocumento || notaDebito.numeroDocumento || recibo.numeroDocumento',
      label: 'Número Documento',
      type: 'text',
      icon: 'receipt',
      mask: '0*',
      width: '20%',
      validators: [],
    },
  ];

  protected acoes: Acao[] = [
    {
      icon: 'save_alt',
      tooltip: 'Baixar medições',
      action: this.baixarMedicoes.bind(this),
      hide: true,
      },
  ];

  protected colunas: Coluna[] = [
    { name: 'fatura.grupoContrato.numeroGrupoContrato', label: 'Contrato Master' },
    { name: 'sum(valores.valor)', label: 'Valor Fatura', format: currencyBRL },
    { name: 'fatura.tipoFatura + fatura.numeroDocumento', label: 'Número Documento' },
    { name: 'dataEmissao', label: 'Data Emissão', format: dateFormat },
    { name: 'dataVencimentoBase', label: 'Data Vencimento', format: dateFormat },
    {
      name: 'acoes',
      label: 'Ações',
      acoes: [
        {
          label: 'Ver detalhes',
          icon: 'visibility',
          action: this.verDetalhes.bind(this),
        },
      ],
    },
  ];

  constructor(
    public faturamentoController: FaturamentoController,
    private contratoRepository: ContratoRepository,
    private dialog: MatDialog,
  ) {
    super('Faturamento - Portal do Cliente', faturamentoController);
  }

  private baixarMedicoes() {}

  private verDetalhes(fatura: FaturamentoModel) {
    const ref = this.dialog.open(DetalhesFaturamentoComponent, {
      width: '800px',
      height: '600px',
      data: { id: fatura.id },
    });

    ref.afterClosed().subscribe((result: boolean) => {
      if (result) {
        modal.fire({
          title: 'Sucesso!',
          text: 'Faturamento atualizado com sucesso!',
          icon: 'success',
          confirmButtonText: 'Continuar',
        });
      }
    });
  }
}
